export enum EntityWithIdFields {
    Id = 'id'
}

export interface EntityWithId<TId> {
    [EntityWithIdFields.Id]: TId;
}

export enum EntityWithIdAndDescriptionFields {
    Id = 'id',
    Description = 'descripcion'
}
export interface EntityWithIdAndDescription extends EntityWithId<number> {
    [EntityWithIdAndDescriptionFields.Description]: string;
}

export enum EntityPaginationFields {
    CantPages = 'cantPages',
    ActualPage = 'actualPage',
    CantRecords = 'cantRecords',
    PageSize = 'pageSize',
    OrderBy = 'orderBy'
}

export interface EntityPagination {
    [EntityPaginationFields.CantPages]: number;
    [EntityPaginationFields.ActualPage]: number;
    [EntityPaginationFields.CantRecords]: number;
    [EntityPaginationFields.PageSize]: number;
}

export interface EntityFilterPagination {
    [EntityPaginationFields.ActualPage]: number;
    [EntityPaginationFields.PageSize]: number;
    [EntityPaginationFields.OrderBy]?: string;
}

export enum EntityListWithPaginationFields {
    List = 'lista',
    Pagination = 'paginacion'
}

export interface EntityListWithPagination<T> {
    [EntityListWithPaginationFields.List]: T[];
    [EntityListWithPaginationFields.Pagination]: EntityPagination;
}

export enum BaseResponseFields {
    Data = 'data',
    HasError = 'tieneError',
    ErrorDescription = 'descripcionError',
}

export interface BaseResponse {
    [BaseResponseFields.HasError]: boolean;
    [BaseResponseFields.ErrorDescription]: string;
}

export interface EntityFilter {
    [key: string]: any,
    intPageSize?: number;
    intActualPage?: number;
    vchOrderBy?: string;
}

export interface BaseResponseWithData<T> {
    [BaseResponseFields.Data]: T;
    [BaseResponseFields.HasError]: boolean;
    [BaseResponseFields.ErrorDescription]: string;
}

export enum BaseRequestFields {
    ModuleCode = 'codModulo',
    OriginCode = 'codOrigen'
}

export interface BaseRequest {
    [BaseRequestFields.ModuleCode]: number;
    [BaseRequestFields.OriginCode]: number;
}

export interface EntityResponse {
    tieneError: boolean;
    descripcionError: string;
}